import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledInfoContainer = styled.div`
	background: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	padding: 20px;
	margin-top: 20px;
	display: grid;
	grid-template-columns: auto auto;
	row-gap: 20px;
	justify-content: space-between;

	${Text} {
		color: #ffffff;
		font-weight: 400;
		font-size: 16px;
	}

	& > ${Text}:nth-child(2n + 1) {
		opacity: 0.5;
		font-size: 16px;
		font-weight: 400;
	}

	& div:nth-child(2n) {
		justify-self: end;
	}
`;

const StyledHomeStatusContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		user-select: none;
	}
`;

const StyledBuyContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 30px;
`;

const StyledRubleContainer = styled.div`
	display: flex;
	gap: 10px;
	justify-content: flex-end;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	img {
		margin-top: 1px;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledHomeImage = styled.img`
	width: 100%;
	height: 176px;
	object-fit: cover;
	user-select: none;
	pointer-events: none;
	border-radius: 10px;
`;

const StyledInfoItemsContainers = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;
	margin-top: 17px;
`;

const StyledInfoItem = styled.div`
	height: 60px;
	background: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;

	${Text} {
		&:first-child {
			font-size: 12px;
			color: #ffffff;
			opacity: 0.5;
		}

		&:last-child {
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
		}
	}
`;

const StyledNotOwnerContainer = styled.div`
	margin-top: 90px;
`;

const StyledOwnerContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 30px;
`;

export {
	StyledButtonContent,
	StyledBuyContainer,
	StyledHomeImage,
	StyledHomeStatusContainer,
	StyledInfoContainer,
	StyledInfoItem,
	StyledInfoItemsContainers,
	StyledNotOwnerContainer,
	StyledOwnerContainer,
	StyledRubleContainer,
};
